export const typeOfBusiness = [
	{
		label: "Sole Proprietor",
		value: "SoleProp",
	},
	{
		label: "Limited Liability Company",
		value: "LLC",
	},
	{
		label: "Private Corporation",
		value: "PrivateCorporation",
	},
	{
		label: "Public Corporation",
		value: "PublicCorporation",
	},
	{
		label: "Government",
		value: "Government",
	},
	{
		label: "Partnership",
		value: "Partnership",
	},
	{
		label: "Trust / Estate",
		value: "TrustEstate",
	},
	{
		label: "Tax Exempt 501 (c)(3)",
		value: "TaxExtemp501c",
	},
	{
		label: "Other",
		value: "Other",
	},
];

